import React from "react";
import { IEvent } from "@Interfaces";
import UpsellListingCard from "@Modules/eventPage/components/UpsellListings/components/UpsellListingCard";
import PaymentSummary from "@Modules/eventPage/components/PaymentSummary";
// import { FaReceipt } from "@react-icons/all-files/fa/FaReceipt";
import moduleStyle from "./OrderBumps.module.scss";
import { useOrderBumps } from "./useOrderBumps";

export const OrderBumps = () => {
    const { upsellListingProps } = useOrderBumps();
    const { upsellListings, sectionTitle } = upsellListingProps;

    return (
        <div className={`${moduleStyle.container}`}>
            <div className={`${moduleStyle.paymentSummaryConatiner} p-2 mb-4`}>
                <PaymentSummary showExpandedBill />
                {/* TODO: keeping it here to handle expanded summary with icon */}
                {/* <FaReceipt
                    id="receiptIcon"
                    className={`${moduleStyle.receiptIcon}`}
                /> */}
            </div>
            <div className={`${moduleStyle.sectionTitle} mb-2   `}>
                {sectionTitle}
            </div>
            <div>
                {upsellListings?.map((item: IEvent.IUpsellOffering) => (
                    <UpsellListingCard
                        {...upsellListingProps}
                        item={item}
                        showBlinker
                        key={item.id}
                        classes={{ cardClasses: "my-3" }}
                    />
                ))}
            </div>
        </div>
    );
};
